var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_2983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.396 18.6136L20.0397 15.2643C18.841 14.0681 16.8033 14.5467 16.3238 16.1016C15.9642 17.1782 14.7655 17.7763 13.6867 17.537C11.2893 16.9389 8.05287 13.8289 7.45353 11.317C7.09393 10.2404 7.81314 9.04419 8.89195 8.68538C10.4502 8.20691 10.9297 6.17343 9.73103 4.97726L6.37471 1.62799C5.41577 0.790671 3.97734 0.790671 3.13826 1.62799L0.860763 3.90071C-1.41674 6.29305 1.1005 12.6327 6.73432 18.2547C12.3681 23.8767 18.7212 26.5083 21.1185 24.116L23.396 21.8432C24.2352 20.8863 24.2352 19.4509 23.396 18.6136Z",
    fill: "#FB8E00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_2983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7ad6af7a40d1ba1f054ca86c21e621f1.svg";
export { ForwardRef as ReactComponent };